module.exports = __webpack_public_path__ + "static/media/aroma-full.376e91b8.png";